module.exports = __webpack_public_path__ + "img/CodeLink.0f79c306.svg";